import { createDownloadWithProgressThunk } from 'partner360/components/asyncContentWrapper/model'

import { downloadProgress, downloadStarted } from '../actions'
import { DOWNLOAD_TYPE_PREFIX } from '../constants'

export const downloadWithProgress = createDownloadWithProgressThunk(DOWNLOAD_TYPE_PREFIX, {
  downloadStarted,
  downloadProgress,
})
